// extracted by mini-css-extract-plugin
module.exports = {"hiddenVideo":"styles-module--hiddenVideo--2VaHc"};